module.exports = __webpack_public_path__ + "img/scene1-2.115559f9.png";